import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VApp,{staticClass:"white layers-design-system ls-ma-0",attrs:{"id":"app"}},[_c('router-view',{attrs:{"name":"app"}}),_c('router-view',{attrs:{"name":"header"}}),_c('router-view',{attrs:{"name":"navigation"}}),_c(VMain,[_c('transition',{attrs:{"name":_vm.transitionName,"mode":"out-in"}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }